'use client';

import { useLocalStorage } from '@shared/hooks';
import type { LayoutVariant } from '../../../casino/types/types';

const LOCAL_STORAGE_KEY = 'll-casino-layout';
const DEFAULT_LAYOUT = 'grid';
const VALID_LAYOUTS: LayoutVariant[] = ['grid', 'list'];

function isLayoutVariant(value: unknown): value is LayoutVariant {
  return (VALID_LAYOUTS as unknown[]).includes(value);
}

/**
 * Hook to manage the display preference (grid/list)
 * with persistence in localStorage.
 */
function useLayoutPreference() {
  const [layout, setLayout] = useLocalStorage<LayoutVariant>(LOCAL_STORAGE_KEY, DEFAULT_LAYOUT, isLayoutVariant);

  const updateLayout = (newLayout: LayoutVariant) => {
    if (VALID_LAYOUTS.includes(newLayout)) {
      setLayout(newLayout);
    }
  };

  return {
    layout,
    updateLayout,
  };
}

export { useLayoutPreference };
